

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- <div dir="rtl" class="container">
    <div class="side-bar">

    </div>
    
</div> -->

<div class="ccc">

    <router-outlet></router-outlet>
    <app-popup></app-popup>

    
    <div class="footer">
        האתר נבנה לע"נ ישראל יעקב בן יצחק אייזיק, ברוך בן יוסף יום טוב ואריה בן אהרון פסח
    </div>

</div>
